import styled from 'styled-components';

export const ItemWrapper = styled.li`
  display: flex;
  flex-direction: column;
  width: 300px;

  @media print {
  width: 45 %;

  img {
    @media print {
    height: 220px;
    } 
  }
}
`;

export const ImageTitle = styled.h3`
  margin-top: 15px;
  margin: 0;
  font-size: 1.25rem;
  font-weight: 700;
  margin-top: 20px;
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0;
  margin-top: 20px;
  margin-bottom: 50px;
  word-break: break-word;
  
  @media print {
    margin-top: 5px;
    font-size: 0.875rem;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    word-break: break-word;
    -webkit-box-orient: vertical;
  }
`;
